import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import images from "assets/images";
import {
  aqqarOnboardingContent,
  loanRequestContent,
} from "content/loan_request";
import TermsCheckbox from "pages/loan_request-mf/components/TermsCheckbox";
import "../../../style/components/_aqqar-onboarding.scss";

interface Props {
  checked: boolean;
  setChecked: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
  onSubmit: () => void;
  onTermsClick: () => void;
}

const features = [
  { icon: images.aqqarIslamicIcon, text: aqqarOnboardingContent.featureIslamic },
  {
    icon: images.aqqarInstallmentPlanIcon,
    text: aqqarOnboardingContent.featureInstallmentPlan,
  },
  { icon: images.aqqarWalletIcon, text: aqqarOnboardingContent.featureWallet },
  {
    icon: images.aqqarSuppliersIcon,
    text: aqqarOnboardingContent.featureSuppliers,
  },
];

const AqqarOnboarding: FC<Props> = ({
  checked,
  setChecked,
  onClose,
  onSubmit,
  onTermsClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="form-modal-overlay">
      <div className="aqqar-onboarding">
        <div className="aqqar-onboarding__banner">
          <button className="aqqar-onboarding__close" onClick={onClose}>
            <img src={images.icon_close_blue} alt="close" />
          </button>
          <img
            className="aqqar-onboarding__hero"
            src={images.aqqarOnboardingHeader}
            alt=""
          />
        </div>

        <div className="aqqar-onboarding__body">
          <h2 className="aqqar-onboarding__title">
            {t(loanRequestContent.aqqarHeader)}
          </h2>
          <p className="aqqar-onboarding__subtitle">
            {t(aqqarOnboardingContent.subtitle)}
          </p>

          <ul className="aqqar-onboarding__features">
            {features.map((feature) => (
              <li className="aqqar-onboarding__feature" key={feature.text}>
                <img src={feature.icon} alt="" />
                <p>{t(feature.text)}</p>
              </li>
            ))}
          </ul>

          <div className="aqqar-onboarding__terms">
            <TermsCheckbox
              label={t(aqqarOnboardingContent.termsLabel)}
              linkText={t(aqqarOnboardingContent.termsLink)}
              checked={checked}
              onChange={setChecked}
              onLinkClick={onTermsClick}
              labelStyle={{ fontSize: "15px", color: "#6B7280" }}
              linkStyle={{ fontSize: "15px", color: "#E9581E" }}
            />
          </div>

          <button
            className="aqqar-onboarding__submit"
            onClick={onSubmit}
            disabled={!checked}
          >
            {t(loanRequestContent.aqqarRequestBtn)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AqqarOnboarding;
